import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

const SmartImage = ({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  ratio = "aspect-[16/10]",
  loading = "lazy",
}) => {
  const [loaded, setLoaded] = React.useState(false);
  const [errored, setErrored] = React.useState(false);

  return (
    <div className={cn("relative overflow-hidden", ratio, className)}>
      {!loaded && !errored && (
        <Skeleton className="absolute inset-0 h-full w-full bg-white/5" />
      )}
      {!errored && (
        <img
          src={src}
          alt={alt}
          loading={loading}
          onLoad={() => setLoaded(true)}
          onError={() => setErrored(true)}
          className={cn(
            "absolute inset-0 h-full w-full object-cover transition-opacity duration-700",
            loaded ? "opacity-100" : "opacity-0",
            imgClassName
          )}
        />
      )}
      {errored && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/4 text-white/40 text-xs tracking-[0.2em] uppercase">
          Image unavailable
        </div>
      )}
    </div>
  );
};

export default SmartImage;
